module.exports = __webpack_public_path__ + "static/img/orderD5.6ceb246b.png";